import styled from 'styled-components';
import { BsCheck } from 'react-icons/bs';

import ButtonCta from '../ButtonCta';
import { addPanelStyle } from '../../lib/mixins';
import { pxToRem, svgComponentToDataURI } from '../../lib/utils';

export const StyledList = styled.ul`
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  margin: 0;
  padding: 0;

  /* li.offer-sfogliatore {
    display: none;
  }
  li.offer-carta {
    display: none;
  } */

  @media screen and (min-width: ${({ theme }) => pxToRem(theme.breakpoints.medium)}) {
    li.offer-sfogliatore {
      display: block;
    }
    li.offer-carta {
      display: block;
    }
  }
`;

export const StyledItem = styled.li`
  display: flex;
  flex-flow: column;
  flex-basis: ${({ brief }) => pxToRem(brief ? 280 : 395)};
  min-height: ${pxToRem(350)};
  margin: 0 ${pxToRem(20)} ${pxToRem(24)};
  padding: ${pxToRem(24)} ${pxToRem(12)} ${pxToRem(32)};
  ${addPanelStyle()}
  box-sizing: border-box;
  list-style: none;

  @media screen and (min-width: ${({ theme }) =>
      pxToRem(theme.breakpoints.medium)}) and (max-width: 1360px) {
    margin-right: ${pxToRem(15)};
    margin-left: ${pxToRem(15)};
  }

  @media screen and (min-width: ${({ theme }) => pxToRem(theme.breakpoints.medium)}) {
    padding-right: ${pxToRem(24)};
    padding-left: ${pxToRem(24)};
  }
`;

export const StyledItemChoose = styled.div`
  display: flex;
  flex: 1;
  flex-flow: column;
  align-items: center;
  text-align: center;
`;

export const StyledItemTitle = styled.h3`
  margin: 0 0 ${pxToRem(4)} 0;
  color: ${({ theme }) => theme.colors.e};
  font-family: ${({ theme }) => theme.fonts.headings};
  font-weight: 700;
  font-size: ${pxToRem(28)};
  line-height: ${pxToRem(36)};
`;

export const StyledItemDescription = styled.p`
  margin: 0 0 ${pxToRem(12)} 0;
  color: ${({ theme }) => theme.colors.e};
  font-size: ${pxToRem(15)};
  line-height: ${pxToRem(21)};
`;

export const StyledItemPrice = styled.span`
  display: block;
  margin-bottom: ${pxToRem(2)};
  color: ${({ theme }) => theme.colors.brand};
  font-family: ${({ theme }) => theme.fonts.headings};
  font-weight: 700;
  font-size: ${pxToRem(30)};
  line-height: 1.2;

  @media screen and (min-width: ${({ theme }) => pxToRem(theme.breakpoints.medium)}) {
    font-size: ${pxToRem(33)};
  }
`;

export const StyledItemSavings = styled.span`
  display: block;
  margin-bottom: ${pxToRem(8)};
  color: ${({ theme }) => theme.colors.success};
  font-weight: 700;
  font-size: ${pxToRem(20)};
  line-height: 1.2;
`;

export const StyledItemChooseItem = styled.div`
  &:not(:first-child) {
    margin-top: ${pxToRem(15)};
    padding-top: ${pxToRem(15)};
    border-top: 1px solid ${({ theme }) => theme.colors.c};
  }
`;

export const StyledItemButtonCta = styled(ButtonCta)`
  width: 100%;
  margin-top: ${pxToRem(15)};
`;

export const StyledItemDetailsItem = styled.li`
  list-style: none;
  margin-bottom: ${pxToRem(12)};

  em {
    display: block;
  }
`;

export const StyledItemDetails = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.f};
  font-size: ${pxToRem(15)};
  line-height: ${pxToRem(21)};
`;

export const StyledItemBenefits = styled.div`
  margin-top: ${pxToRem(20)};
  padding-top: ${pxToRem(20)};
  border-top: 1px solid ${({ theme }) => theme.colors.c};
`;

export const StyledItemBenefitsTitle = styled.h5`
  margin: 0 0 ${pxToRem(16)} 0;
  color: ${({ theme }) => theme.colors.g};
  font-size: ${pxToRem(15)};
  font-weight: 700;
  line-height: ${pxToRem(21)};
  text-align: left;
  text-transform: uppercase;
`;

export const StyledItemBenefitsList = styled.ul`
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.e};
  font-size: ${pxToRem(18)};
  line-height: ${pxToRem(26)};
`;

export const StyledItemBenefitsListItem = styled.li`
  padding-left: ${pxToRem(30)};
  list-style: none;
  text-align: left;
  background-image: url('${({ theme }) =>
    svgComponentToDataURI(<BsCheck color={theme.colors.success} size="1.5rem" />)}');
  background-position: left 3px;
  background-repeat: no-repeat;
  background-size: ${pxToRem(24)} auto;

  &:not(:first-child) {
    margin-top: ${pxToRem(8)};
  }
`;
